import { motion } from "framer-motion";
import { useLanguage } from "@/context/LanguageContext";
import { IMAGES } from "@/data/images";

export const About = () => {
  const { t } = useLanguage();
  const a = t.scuba.about;
  return (
    <section id="about" className="relative bg-ocean-deep py-28 md:py-36 px-6 md:px-12 lg:px-20 border-t border-white/10 overflow-hidden">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.7 }}
        >
          <p className="font-mono text-cyan-300 text-xs tracking-[0.25em] mb-4" data-testid="scuba-about-eyebrow">
            {a.eyebrow}
          </p>
          <h2 className="font-syne text-4xl md:text-5xl tracking-tight text-white mb-8" data-testid="scuba-about-title">
            {a.title}
          </h2>
          <p className="font-manrope text-white/70 leading-relaxed">{a.paragraph}</p>
        </motion.div>
        <motion.div
          initial={{ opacity: 0, scale: 0.92 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.8 }}
          className="relative"
        >
          <img
            src={IMAGES.scuba.diverReef}
            alt="Diver with marine life"
            className="w-full h-96 object-cover rounded-[2rem]"
            style={{ clipPath: "polygon(6% 0, 100% 0, 100% 92%, 94% 100%, 0 100%, 0 8%)" }}
          />
        </motion.div>
      </div>
    </section>
  );
};
